import { Link } from "react-router-dom";
import { Phone, ClipboardList } from "lucide-react";
import { BUSINESS } from "@/lib/site";

export const MobileCTA = () => (
  <div
    data-testid="mobile-sticky-cta"
    className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-slate-200 bg-white/95 backdrop-blur-xl md:hidden"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <a
      href={BUSINESS.phoneHref}
      data-testid="mobile-cta-call"
      className="flex items-center justify-center gap-2 bg-navy-800 py-4 font-heading text-sm font-bold text-white active:bg-navy-700"
    >
      <Phone className="h-4 w-4" /> Call Now
    </a>
    <Link
      to="/contact"
      data-testid="mobile-cta-quote"
      className="flex items-center justify-center gap-2 bg-emerald-500 py-4 font-heading text-sm font-bold text-white active:bg-emerald-600"
    >
      <ClipboardList className="h-4 w-4" /> Get a Free Quote
    </Link>
  </div>
);
